module.exports = "../dist/frontend/icons/ui/mockup.svg?049eced72f51065ca22f9b7ed9443bd7";